
export interface UploadImageResponse {
    success: boolean
    filename: string
    url: string
}

class UploadRepository {

    async uploadImage(file: File | Blob, folder: string = 'skus'): Promise<UploadImageResponse> {
        const formData = new FormData()
        formData.append('image', file)
        formData.append('folder', folder)

        const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:5000'
        const url = `${API_BASE_URL}/upload/image`

        // Get token from various sources
        let token: string | null = null
        if (globalThis.window) {
            token = localStorage.getItem('backend_jwt_token') || sessionStorage.getItem('backend_jwt_token')
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': token ? `Bearer ${token}` : '',
            },
            body: formData,
            credentials: 'include',
        })

        if (!response.ok) {
            const errorText = await response.text()
            let errorMessage = 'Failed to upload image'
            try {
                const errorJson = JSON.parse(errorText)
                errorMessage = errorJson.message || errorJson.error || errorMessage
            } catch {
                errorMessage = errorText || errorMessage
            }
            throw new Error(errorMessage)
        }

        return response.json()
    }

    /**
     * Delete image from GCP via backend
     * @param filename - Filename in bucket
     */
    async deleteImage(filename: string): Promise<{ success: boolean; message: string }> {
        const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:5000'
        const url = `${API_BASE_URL}/upload/image/${encodeURIComponent(filename)}`

        let token: string | null = null
        if (globalThis.window) {
            token = localStorage.getItem('backend_jwt_token') || sessionStorage.getItem('backend_jwt_token')
        }

        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Authorization': token ? `Bearer ${token}` : '',
            },
            credentials: 'include',
        })

        if (!response.ok) {
            const errorText = await response.text()
            let errorMessage = 'Failed to delete image'
            try {
                const errorJson = JSON.parse(errorText)
                errorMessage = errorJson.message || errorJson.error || errorMessage
            } catch {
                errorMessage = errorText || errorMessage
            }
            throw new Error(errorMessage)
        }

        return response.json()
    }
}

export const uploadRepository = new UploadRepository()

